import { UploadableFileType } from '@omnea-app/packages/universal/form/elements/files'
import { FormTemplateStateEnum, FormTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'
import type { FormTemplateInsertData } from '../handleExtOpsIntegrationEnabled'
import type { FormConfig } from '@omnea-app/packages/universal/formBuilder/form'

export const ThomsonReutersQuestionIds = {
  businessName: 'businessName',
  totalRiskScore: 'totalRiskScore',
  totalMatchScore: 'totalMatchScore',
  riskFlagName_1: 'riskFlagName_1',
  riskFlagScore_1: 'riskFlagScore_1',
  riskFlagName_2: 'riskFlagName_2',
  riskFlagScore_2: 'riskFlagScore_2',
  riskFlagName_3: 'riskFlagName_3',
  riskFlagScore_3: 'riskFlagScore_3',
  riskFlagName_4: 'riskFlagName_4',
  riskFlagScore_4: 'riskFlagScore_4',
  riskFlagName_5: 'riskFlagName_5',
  riskFlagScore_5: 'riskFlagScore_5',
  riskFlagName_6: 'riskFlagName_6',
  riskFlagScore_6: 'riskFlagScore_6',
  riskFlagName_7: 'riskFlagName_7',
  riskFlagScore_7: 'riskFlagScore_7',
  riskFlagName_8: 'riskFlagName_8',
  riskFlagScore_8: 'riskFlagScore_8',
  riskFlagName_9: 'riskFlagName_9',
  riskFlagScore_9: 'riskFlagScore_9',
  riskFlagName_10: 'riskFlagName_10',
  riskFlagScore_10: 'riskFlagScore_10',
  thomsonReutersGeneratedReport: 'thomsonReutersGeneratedReport',
} as const

const config: FormConfig = {
  logic: {},
  pages: [
    {
      id: 'cbaae8fc-2696-4cce-add7-2e925ca170ef',
      name: 'overview',
      title: 'Company details',
      questions: [
        {
          id: '6e199f57-b026-4e70-b5ae-e704ea13fe33',
          name: ThomsonReutersQuestionIds.businessName,
          type: 'text',
          title: 'Registered name',
          readOnly: false,
          visibleIf: [],
          isRequired: false,
        },
      ],
    },
    {
      id: '759f52b0-922a-4ad7-b58b-fa7bce673f7d',
      name: 'risk-overview',
      title: 'Risk Overview',
      questions: [
        {
          id: '0e205903-cf76-4e63-8883-e7789bcc127e',
          name: ThomsonReutersQuestionIds.totalRiskScore,
          type: 'number',
          title: 'Total Risk Score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'e0834709-bd9e-4e39-afee-ddbbf1dc2b3f',
          name: ThomsonReutersQuestionIds.totalMatchScore,
          type: 'number',
          title: 'Total Match Score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'a5fa1bab-6e35-44ce-819c-781e118e7357',
          name: ThomsonReutersQuestionIds.thomsonReutersGeneratedReport,
          type: 'files',
          title: 'PDF Report',
          visibleIf: [],
          isRequired: false,
          multipleFiles: true,
          supportedTypes: [
            UploadableFileType.ZIP,
            UploadableFileType.IMAGE,
            UploadableFileType.PDF,
            UploadableFileType.CSV,
            UploadableFileType.WORD,
            UploadableFileType.EXCEL,
          ],
          storeFilesGlobally: true,
        },
        {
          id: 'ace88c2f-65e8-4440-be91-2457117a777e',
          name: ThomsonReutersQuestionIds.riskFlagName_1,
          type: 'text',
          title: 'Risk #1 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'ace88c2f-65e8-4440-be91-2457117a777f',
          name: ThomsonReutersQuestionIds.riskFlagScore_1,
          type: 'number',
          title: 'Risk #1 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'a75468b7-bc7e-40f6-ae87-294f73905c84',
          name: ThomsonReutersQuestionIds.riskFlagName_2,
          type: 'text',
          title: 'Risk #2 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'a75468b7-bc7e-40f6-ae87-294f73905c85',
          name: ThomsonReutersQuestionIds.riskFlagScore_2,
          type: 'number',
          title: 'Risk #2 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'd6b73771-36c6-4306-9278-8b574cc1f02d',
          name: ThomsonReutersQuestionIds.riskFlagName_3,
          type: 'text',
          title: 'Risk #3 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'd6b73771-36c6-4306-9278-8b574cc1f02e',
          name: ThomsonReutersQuestionIds.riskFlagScore_3,
          type: 'number',
          title: 'Risk #3 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '3ee99951-7cd6-43ac-a89f-02dd01da9766',
          name: ThomsonReutersQuestionIds.riskFlagName_4,
          type: 'text',
          title: 'Risk #4 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '3ee99951-7cd6-43ac-a89f-02dd01da9767',
          name: ThomsonReutersQuestionIds.riskFlagScore_4,
          type: 'number',
          title: 'Risk #4 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'fd41b04f-d1bc-43f2-9f7a-27b80fafc02e',
          name: ThomsonReutersQuestionIds.riskFlagName_5,
          type: 'text',
          title: 'Risk #5 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'fd41b04f-d1bc-43f2-9f7a-27b80fafc02f',
          name: ThomsonReutersQuestionIds.riskFlagScore_5,
          type: 'number',
          title: 'Risk #5 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '13fa4169-4895-4395-82d3-c9ae6ec41092',
          name: ThomsonReutersQuestionIds.riskFlagName_6,
          type: 'text',
          title: 'Risk #6 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '13fa4169-4895-4395-82d3-c9ae6ec41093',
          name: ThomsonReutersQuestionIds.riskFlagScore_6,
          type: 'number',
          title: 'Risk #6 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'decb8205-5528-4759-a982-d6342fc178fb',
          name: ThomsonReutersQuestionIds.riskFlagName_7,
          type: 'text',
          title: 'Risk #7 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'decb8205-5528-4759-a982-d6342fc178fc',
          name: ThomsonReutersQuestionIds.riskFlagScore_7,
          type: 'number',
          title: 'Risk #7 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'ff75fd3f-453a-467e-aa32-7014f17b856e',
          name: ThomsonReutersQuestionIds.riskFlagName_8,
          type: 'text',
          title: 'Risk #8 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: 'ff75fd3f-453a-467e-aa32-7014f17b856f',
          name: ThomsonReutersQuestionIds.riskFlagScore_8,
          type: 'number',
          title: 'Risk #8 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '4b56db6e-fdd4-456b-9089-46a738a7c395',
          name: ThomsonReutersQuestionIds.riskFlagName_9,
          type: 'text',
          title: 'Risk #9 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '4b56db6e-fdd4-456b-9089-46a738a7c396',
          name: ThomsonReutersQuestionIds.riskFlagScore_9,
          type: 'number',
          title: 'Risk #9 score',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '80e44ec3-a5d7-4fd0-9906-d2bb55a9a973',
          name: ThomsonReutersQuestionIds.riskFlagName_10,
          type: 'text',
          title: 'Risk #10 name',
          visibleIf: [],
          isRequired: false,
        },
        {
          id: '80e44ec3-a5d7-4fd0-9906-d2bb55a9a974',
          name: ThomsonReutersQuestionIds.riskFlagScore_10,
          type: 'number',
          title: 'Risk #10 score',
          visibleIf: [],
          isRequired: false,
        },
      ],
    },
  ],
  enableAiSummary: true,
  enableAiAutoFill: false,
}

// TODO (WINT-645): Update config to match the new form template question schema
export const formTemplate = {
  title: 'Thomson Reuters Report',
  state: FormTemplateStateEnum.PUBLISHED,
  type: FormTypeEnum.EXTERNAL_OPERATION,
  integration: 'thomson-reuters',
  description: 'This form is used to capture the output of the Thomson Reuters integration',
  config,
} satisfies FormTemplateInsertData

export const ThomsonReutersQuestionTemplatesArray = config.pages.flatMap((page) => page.questions)
export const ThomsonReutersQuestionIdsArray = Object.values(ThomsonReutersQuestionIds)
